import {
  associatedItemsRenderer,
  dateRenderer,
  dateSorter,
  entityNameSorter,
  getProp,
  numericSorter,
  priceWithCurrencyRenderer
} from '@lib/generic.utils'
import { agPriceCol, agStartDateCol } from '@/ag-grid/ag-columns'

export const gridOptions = {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: 'Invoice',
            field: 'invoice_number',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'TextEditor',
            cellRenderer: params => params.value || 'N/A',
            tooltipValueGetter: params => `Invoice ${params.value || 'N/A'}`
          },

          agPriceCol('Amount', 'amount'),

          {
            headerName: 'Items',
            field: 'items_count',
            comparator: numericSorter,
            tooltipValueGetter: params => associatedItemsRenderer(params.value)
          },

          agStartDateCol({
            headerName: 'Issued on',
            field: 'issue_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          agStartDateCol({
            headerName: 'Due on',
            field: 'due_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor'
          }),

          {
            headerName: 'Approved by',
            field: 'created_by',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name'),
            tooltipValueGetter: params => getProp(params.value, 'name')
          },

          agStartDateCol({
            headerName: 'Approved on',
            field: 'created_at'
          }),

          {
            headerName: 'Paid by',
            field: 'vendor_payment.created_by',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name'),
            tooltipValueGetter: params => getProp(params.value, 'name')
          },

          agStartDateCol({
            headerName: 'Paid on',
            field: 'vendor_payment.payment_date',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'DateEditor',
            valueGetter: params => params.data.vendor_payment?.payment_date
          }),

          {
            headerName: 'Amount local currency',
            field: 'vendor_payment.paid_amount',
            comparator: numericSorter,
            headerClass: 'price-column',
            cellStyle: { textAlign: 'right', paddingRight: '15px !important' },
            cellRenderer: params => priceWithCurrencyRenderer(params, 'vendor_payment.currency'),
            tooltipValueGetter: params => priceWithCurrencyRenderer(params, 'vendor_payment.currency', true)
          },

          {
            headerName: 'Payment ref',
            field: 'vendor_payment.payment_reference',
            tooltipField: 'vendor_payment.payment_reference',
            editable: true,
            cellClass: ['editable-cell'],
            cellEditorFramework: 'TextEditor',
            cellRenderer: params => params.value || 'N/A'
          }
        ],

        domLayout: 'autoHeight'
      }
    }
  }
}
